import { RolesEnum } from '../enums/roles.enum';

export function checkRoles(requiredRoles: RolesEnum[], userRoles: RolesEnum[]): boolean {
  return requiredRoles.some((role) => userRoles.includes(role));
}
